import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner',
  template: `<div class="Spinner" fxLayout="row" fxLayoutAlign="center">
  <mat-spinner [diameter]="diameter"></mat-spinner>
  </div>`,
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent{
  @Input() diameter = "70";

}
